<div
  class="static-calendar"
  wctDatepicker
  (dateChange)="setDate($event)"
  [date]="selectedDate()"
  [disabledDates]="isDateDisabled"
  [minDate]="rangeMin()"
  [maxDate]="rangeMax()"
  [appendTo]="datepickerContainer">

  <sd-4-5-1-input size="sm">
    <div slot="left">
      {{ displayedTimeframe() | datepickerDate }}
    </div>

    <sd-4-5-1-icon
      slot="right"
      library="{{ iconLibrary }}"
      name="system/calendar"></sd-4-5-1-icon>

  </sd-4-5-1-input>
  <div #datepickerContainer class="datepicker-container"></div>
</div>
